/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Link_Error_Order_Not_LinkableInputs */

const vi_vtp_link_error_order_not_linkable = /** @type {(inputs: Vtp_Link_Error_Order_Not_LinkableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng không còn ở trạng thái Đã xuất kho hoặc Sẵn sàng giao`)
};

/**

* @param {Vtp_Link_Error_Order_Not_LinkableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_link_error_order_not_linkable = /** @type {((inputs?: Vtp_Link_Error_Order_Not_LinkableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Link_Error_Order_Not_LinkableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_link_error_order_not_linkable(inputs)
});